import BaseButton from 'base-components/BaseButton/BaseButton';
import { useGridFilterUrlContext } from 'providers/GridFilterUrlProvider';
import { useEffect, useState } from 'react';
import { IoIosArrowBack, IoIosArrowForward } from 'react-icons/io';
import { Col } from 'reactstrap';
import { toInt } from 'utils/number';
import './BasePagination.scss';
import { ResponseBody } from 'models/api/common';

interface BasePaginationProps<T> {
    tableData: T;
}

const BasePagination = <T,>({ tableData }: BasePaginationProps<ResponseBody<T>>) => {
    const { filter, setFilter } = useGridFilterUrlContext();
    const numbersOfEntries = [5, 25, 50, 100];

    const { pageNum, pageSize } = filter;
    const num = tableData.rowsCount > 0 ? pageNum || 1 : 1;
    const size = pageSize || 25;
    const numberOfPages = tableData.rowsCount > 0 ? Math.ceil(tableData.rowsCount / size) : 1;
    const [tempNum, setTempNum] = useState<'' | number>(num);

    useEffect(() => setTempNum(num), [num]);

    const numberHandler = () => {
        if (tempNum && tempNum <= numberOfPages && tempNum !== num)
            setFilter((f) => ({ ...f, pageNum: tempNum }));
        else setTempNum(num);
    };

    return (
        <>
            <Col className="pagination__numbers">
                <div className="selectors">
                    <input
                        value={1}
                        onChange={({ target }) => setTempNum(toInt(target.value, 0) ?? '')}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') numberHandler();
                        }}
                        disabled={!num}
                        onBlur={numberHandler}
                    />
                    <span>{`${num}/${numberOfPages}`}</span>
                </div>

                <div className="buttons">
                    <BaseButton
                        disabled={!num || num === 1}
                        onClick={() =>
                            setFilter((f) => ({ ...f, pageNum: f?.pageNum && f?.pageNum - 1 }))
                        }
                    >
                        <IoIosArrowBack />
                    </BaseButton>
                    <BaseButton
                        disabled={!num || num === numberOfPages}
                        onClick={() =>
                            setFilter((f) => ({ ...f, pageNum: f?.pageNum && f?.pageNum + 1 }))
                        }
                    >
                        <IoIosArrowForward />
                    </BaseButton>
                </div>
            </Col>
            <Col className="pagination__size">
                <span>Количество строк</span>
                <div className="numbers">
                    {numbersOfEntries.map((x) => (
                        <span
                            key={x}
                            className={x === size ? 'selected' : ''}
                            onClick={() => setFilter((f) => ({ ...f, pageNum: 1, pageSize: x }))}
                        >
                            {x}
                        </span>
                    ))}
                </div>
            </Col>
        </>
    );
};

export default BasePagination;
